// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-field{position:relative;margin-top:2rem}.multi-field .indented{padding:3px 23px 11.5px 23px;border-left:5px solid #f7f7f7}.multi-field .indented>label{color:#0072c6}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
